import { render, staticRenderFns } from "./ResidentialAddressForm.vue?vue&type=template&id=384a1d24&scoped=true&"
import script from "./ResidentialAddressForm.vue?vue&type=script&lang=js&"
export * from "./ResidentialAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./ResidentialAddressForm.vue?vue&type=style&index=0&id=384a1d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a1d24",
  null
  
)

export default component.exports